import { GenericModelApi } from "./GenericModelApi";
import { ApiSchema } from "./ApiClient";
import { DocumentSequenceFormData } from "@/formTypes/DocumentSequenceDataType";

export type DocumentSequenceDataType = Partial<ApiSchema["DocumentSequence"]["type"] & DocumentSequenceFormData>;
export const DocumentSequenceApi = new GenericModelApi<"DocumentSequence", DocumentSequenceDataType>("DocumentSequence", "kind");